import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const fileElement = document.getElementById("csvInput");
    const uploadButton = document.getElementById("upload-csv-button");
    fileElement.addEventListener("change", () => {
        uploadButton.hidden = false;
    });
  }
}